import styled from "styled-components";

const CampaignsSubscribedLoader = (props) => {
  return (
    <>
      <Wrapper>
        <div className="sk-container">
          <div className="d-flex flex-column">
            <span className="skeleton-box mb-3 redius-1" style={{ height: "25px", width: "200px" }}></span>
            <div className="d-flex flex-row justify-content-between" style={{ padding: "0 24px" }}>
              <div className="d-flex flex-column company-name-first">
                <span className="skeleton-box redius-1" style={{ height: "20px", width: "80px" }}></span>
              </div>
              <span className="skeleton-box redius-1" style={{ height: "20px", width: "60px" }}></span>
              <span className="skeleton-box redius-1" style={{ height: "20px", width: "30px" }}></span>
              <span className="skeleton-box redius-1" style={{ height: "20px", width: "60px" }}></span>
              <span className="skeleton-box redius-1" style={{ height: "20px", width: "80px" }}></span>
            </div>
            <div className="d-flex flex-row justify-content-between mt-3 profile-wrapper">
              <div className="d-flex flex-column company-name-first">
                <span className="skeleton-box redius-1" style={{ height: "20px", width: "150px" }}></span>
                <span className="skeleton-box redius-1 mt-2" style={{ height: "15px", width: "80px" }}></span>
              </div>
              <span className="skeleton-box redius-1" style={{ height: "20px", width: "60px" }}></span>
              <span className="skeleton-box redius-1" style={{ height: "20px", width: "30px" }}></span>
              <span className="skeleton-box redius-1" style={{ height: "20px", width: "60px" }}></span>
              <span className="skeleton-box redius-1" style={{ height: "20px", width: "80px" }}></span>
            </div>
            <div className="d-flex flex-row justify-content-between mt-3 profile-wrapper">
              <div className="d-flex flex-column company-name-first">
                <span className="skeleton-box redius-1" style={{ height: "20px", width: "150px" }}></span>
                <span className="skeleton-box redius-1 mt-2" style={{ height: "15px", width: "80px" }}></span>
              </div>
              <span className="skeleton-box redius-1" style={{ height: "20px", width: "60px" }}></span>
              <span className="skeleton-box redius-1" style={{ height: "20px", width: "30px" }}></span>
              <span className="skeleton-box redius-1" style={{ height: "20px", width: "60px" }}></span>
              <span className="skeleton-box redius-1" style={{ height: "20px", width: "80px" }}></span>
            </div>
            <div className="d-flex flex-row justify-content-between mt-3 profile-wrapper">
              <div className="d-flex flex-column company-name-first">
                <span className="skeleton-box redius-1" style={{ height: "20px", width: "150px" }}></span>
                <span className="skeleton-box redius-1 mt-2" style={{ height: "15px", width: "80px" }}></span>
              </div>
              <span className="skeleton-box redius-1" style={{ height: "20px", width: "60px" }}></span>
              <span className="skeleton-box redius-1" style={{ height: "20px", width: "30px" }}></span>
              <span className="skeleton-box redius-1" style={{ height: "20px", width: "60px" }}></span>
              <span className="skeleton-box redius-1" style={{ height: "20px", width: "80px" }}></span>
            </div>
          </div>
        </div>
      </Wrapper>
    </>
  );
};

export default CampaignsSubscribedLoader;

const Wrapper = styled.div`
  overflow: hidden;
  @-webkit-keyframes shimmer {
    100% {
      -webkit-transform: translateX(100%);
      transform: translateX(100%);
    }
  }

  @keyframes shimmer {
    100% {
      -webkit-transform: translateX(100%);
      transform: translateX(100%);
    }
  }
  .sk-container {
    width: 100%;
    padding: 0px;
    margin: 0;
    .clear {
      clear: both;
    }
    .company-name-first {
      width: calc(100% - 510px);
      @media (max-width: 1439px) {
        width: calc(100% - 350px);
      }
    }
    .profile-wrapper {
      background-color: #ffffff;
      padding: 18px 24px;
      border-radius: 10px;
      box-shadow: 0px 0px 17px -2px rgb(0 0 0 / 8%);
    }
    .skeleton-box {
      display: inline-block;
      height: 1em;
      position: relative;
      overflow: hidden;
      background-color: #e9e9e9;
      &.redius-1 {
        border-radius: 10px;
      }
      &:after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        -webkit-transform: translateX(-100%);
        transform: translateX(-100%);
        background-image: -webkit-gradient(
          linear,
          left top,
          right top,
          color-stop(0, rgba(255, 255, 255, 0)),
          color-stop(20%, rgba(255, 255, 255, 0.2)),
          color-stop(60%, rgba(255, 255, 255, 0.5)),
          to(rgba(255, 255, 255, 0))
        );
        background-image: linear-gradient(
          90deg,
          rgba(255, 255, 255, 0) 0,
          rgba(255, 255, 255, 0.2) 20%,
          rgba(255, 255, 255, 0.5) 60%,
          rgba(255, 255, 255, 0)
        );
        -webkit-animation: shimmer 2s infinite;
        animation: shimmer 2s infinite;
        content: "";
      }
    }
  }
`;
